import type { TermsTranslations } from '../en-US/terms.translations';

export const termsTranslations: TermsTranslations = {
  title: 'Termos e Condições',
  lastUpdated: 'Última atualização: 7 de março de 2025',
  sections: {
    introduction: {
      title: 'Introdução',
      content:
        'Bem-vindo ao BiteCritic. Ao utilizar a nossa plataforma, concorda com estes termos e condições. Por favor, leia-os atentamente.',
    },
    userAgreement: {
      title: 'Acordo do Utilizador',
      content:
        'Ao criar uma conta no BiteCritic, aceita as seguintes responsabilidades:',
      items: [
        'Fornecer informações precisas e completas durante o registo.',
        'Manter a confidencialidade da sua palavra-passe.',
        'Ser responsável por todas as atividades na sua conta.',
        'Notificar imediatamente o BiteCritic de qualquer uso não autorizado.',
        'Não utilizar a conta de outra pessoa sem autorização.',
      ],
    },
    content: {
      title: 'Diretrizes de Conteúdo',
      content:
        'Todo o conteúdo que publica no BiteCritic deve cumprir estas diretrizes:',
      items: [
        'As críticas devem ser honestas e baseadas em experiências reais.',
        'Não publicar conteúdo difamatório, obsceno ou ofensivo.',
        'Não publicar conteúdo que viole direitos de autor ou propriedade intelectual.',
        'Não utilizar a plataforma para spam ou atividades comerciais não autorizadas.',
        'As fotografias devem ser autênticas e respeitar a privacidade dos outros.',
      ],
    },
    contentRights: {
      title: 'Direitos de Conteúdo e Retenção',
      content: 'Relativamente ao seu conteúdo no BiteCritic:',
      items: [
        'Mantém a propriedade do seu conteúdo, mas concede-nos uma licença mundial, não exclusiva e livre de royalties para utilizar, exibir, distribuir, reproduzir, modificar e criar obras derivadas do seu conteúdo em conexão com o Serviço e para fins promocionais e de marketing do BiteCritic, incluindo, mas não limitado a, exibição no nosso site, aplicação e plataformas de terceiros como redes sociais',
        'Quando elimina a sua conta, as suas informações pessoais serão anonimizadas, mas as suas avaliações e outro conteúdo contribuído podem ser mantidos',
        'O conteúdo aparecerá como publicado por um "Utilizador Anónimo" após a eliminação da conta',
        'Para a eliminação completa de todo o conteúdo, deve contactar-nos diretamente em hurricanesoftwaresolutions@gmail.com',
        'Podemos continuar a exibir avaliações anonimizadas para preservar o valor da plataforma para todos os utilizadores',
      ],
    },
    privacy: {
      title: 'Privacidade',
      content:
        'Respeitamos a sua privacidade e estamos empenhados em proteger os seus dados pessoais:',
      items: [
        'Recolhemos apenas as informações necessárias para o funcionamento da plataforma.',
        'Os seus dados pessoais não serão vendidos a terceiros.',
        'Pode solicitar uma cópia dos seus dados ou a sua eliminação.',
        'Utilizamos cookies para melhorar a sua experiência na plataforma.',
        'Para mais informações, consulte a nossa Política de Privacidade completa.',
      ],
    },
    community: {
      title: 'Diretrizes da Comunidade',
      content: 'Para manter uma comunidade respeitosa, siga estas diretrizes:',
      items: [
        'Tratar todos os membros com respeito e cortesia.',
        'Não assediar, intimidar ou discriminar outros utilizadores.',
        'Respeitar opiniões divergentes e participar em discussões construtivas.',
        'Denunciar qualquer conteúdo inadequado ou comportamento abusivo.',
        'Não criar múltiplas contas ou fazer-se passar por outras pessoas.',
      ],
    },
    termination: {
      title: 'Encerramento de Conta',
      content:
        'O BiteCritic reserva-se o direito de suspender ou encerrar a sua conta nas seguintes circunstâncias:',
      items: [
        'Violação destes termos e condições.',
        'Comportamento abusivo para com outros utilizadores.',
        'Publicação de conteúdo inadequado ou ilegal.',
        'Utilização da plataforma para atividades fraudulentas.',
        'Inatividade prolongada da conta.',
        'Anonimizar dados de utilizador mas manter conteúdo quando uma conta é eliminada',
        'Processar pedidos de eliminação completa enviados por email dentro de 30 dias',
      ],
    },
  },
  agreement: {
    checkbox:
      'Li e aceito os Termos e Condições e a Política de Privacidade do BiteCritic.',
    required: 'Deve aceitar os termos e condições para continuar.',
    view: 'Ver termos e condições completos',
  },
};

export default termsTranslations;
